export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13777.3bb2ea18.jpg";